import { styled } from '@mui/material';
import { rem } from 'polished';
import { StyledSubMenu } from './sidebar/sidebar.styled';

export const StyledLayout = styled('div')(
  ({ theme }) =>
    ({
      '--sidebar-header-height': '50px',
      '--header-height': '50px',
      '--footer-height': '50px',
      '--sidebar-header-z': '100',
      '--sidebar-submenu-z': '100',
      '--sidebar-z': '100',
      '--header-z': '100',
      '--footer-z': '100',

      [theme.breakpoints.up('sm')]: {
        '--sidebar-header-height': '60px',
        '--header-height': '60px',
        '--footer-height': '0',
        '--sidebar-z': '110',
        '--sidebar-header-z': '110',
        '--header-z': '110',

        display: 'grid',
        gridTemplateColumns: `${rem(70)} 1fr`,
        gridTemplateRows: 'auto 1fr',
      },

      '@media print': {
        // Hide all layout elements except main
        'header, nav, aside, .sidebar, .header, .footer, [data-cy="header"], [data-cy="sidebar"], [class*="sidebar"], [class*="header"], [data-cy="header-breadcrumbs"], [data-cy="header-title"], [data-cy="header-avatar-btn"]':
          {
            display: 'none !important',
          },

        // Reset layout for print
        display: 'block !important',
        gridTemplateColumns: 'none !important',
        gridTemplateRows: 'none !important',
        minHeight: 'auto !important',
        minWidth: 'auto !important',

        // Clean background
        backgroundColor: '#fff !important',
        background: 'none !important',
        backgroundImage: 'none !important',

        // Print color adjustments
        WebkitPrintColorAdjust: 'exact',
        printColorAdjust: 'exact',
        colorAdjust: 'exact',
      },
    }) as any,
);

export const StyledContent = styled('div')(
  ({ theme }) =>
    ({
      minHeight: '100vh',

      main: {
        paddingTop: `calc(var(--header-height) + var(--sidebar-header-height))`,
        paddingBottom: 'var(--footer-height)',
        [theme.breakpoints.up('sm')]: {
          paddingTop: 'unset',
        },
      },

      [theme.breakpoints.up('sm')]: {
        gridRow: '2 / -1',
        display: 'grid',
        gridTemplateColumns: 'auto 1fr',
        gridTemplateRows: 'auto 1fr',
        minWidth: '100vw',
        minHeight: `calc(100vh - var(--header-height))`,

        [StyledSubMenu]: {
          gridColumn: '1 / 1',
          gridRow: '1 / -1',
          top: 'var(--sidebar-header-height)',
        },

        main: {
          gridColumn: '2 / -1',
          gridRow: '1 / -1',
        },
      },

      '@media print': {
        // Reset content layout for print
        display: 'block !important',
        gridTemplateColumns: 'none !important',
        gridTemplateRows: 'none !important',
        minHeight: 'auto !important',
        minWidth: 'auto !important',

        // Hide sidebar and other elements
        [StyledSubMenu]: {
          display: 'none !important',
        },

        // Ensure main takes full width and has no padding/margins
        main: {
          display: 'block !important',
          gridColumn: 'unset !important',
          gridRow: 'unset !important',
          paddingTop: '0 !important',
          paddingBottom: '0 !important',
          paddingLeft: '0 !important',
          paddingRight: '0 !important',
          margin: '0 !important',
          width: '100% !important',
          maxWidth: '100% !important',
          minHeight: 'auto !important',
          position: 'static !important',
          top: 'auto !important',
          left: 'auto !important',
          zIndex: 'auto !important',
        },

        // Clean background
        backgroundColor: '#fff !important',
        background: 'none !important',
        backgroundImage: 'none !important',

        // Print color adjustments
        WebkitPrintColorAdjust: 'exact',
        printColorAdjust: 'exact',
        colorAdjust: 'exact',
      },
    }) as any,
);
